import React from 'react';
import { Z_INDEX_TOUR_OVERLAY, Z_INDEX_TOUR_OVERLAY_MODAL } from '../../constants/zIndex';
import { boundsToClipPath } from '../../utils/onboardingSpotlightClip';

export interface SpotlightOverlayProps {
  spotlightRect: DOMRect | null;
  clipBounds?: DOMRect | null;
  aboveModal?: boolean;
  children?: React.ReactNode;
}

const OVERLAY_COLOR = 'rgba(15, 23, 42, 0.6)';

function OverlayLayers({
  spotlightRect,
  clipBounds,
  aboveModal = false,
}: {
  spotlightRect: DOMRect | null;
  clipBounds?: DOMRect | null;
  aboveModal?: boolean;
}) {
  const clipPath = clipBounds ? boundsToClipPath(clipBounds) : undefined;

  return (
    <div
      className="pointer-events-none fixed inset-0"
      aria-hidden
      style={{
        zIndex: aboveModal ? Z_INDEX_TOUR_OVERLAY_MODAL : Z_INDEX_TOUR_OVERLAY,
        ...(clipPath ? { clipPath, WebkitClipPath: clipPath } : {}),
      }}
    >
      {spotlightRect ? (
        <div
          className="pointer-events-none fixed rounded-lg"
          style={{
            top: spotlightRect.top,
            left: spotlightRect.left,
            width: spotlightRect.width,
            height: spotlightRect.height,
            boxShadow: `0 0 0 9999px ${OVERLAY_COLOR}`,
          }}
        />
      ) : (
        <div className="pointer-events-none fixed inset-0 bg-slate-900/60" />
      )}
    </div>
  );
}

export const SpotlightOverlay: React.FC<SpotlightOverlayProps> = ({
  spotlightRect,
  clipBounds = null,
  aboveModal = false,
  children,
}) => {
  return (
    <>
      <OverlayLayers
        spotlightRect={spotlightRect}
        clipBounds={clipBounds}
        aboveModal={aboveModal}
      />
      {children}
    </>
  );
};
